import React from 'react';
import { ClockIcon, ZapIcon, WalletIcon } from 'lucide-react';
import { StatCard } from '../StatCard';
export function SpecStatsSection() {
  return <section className="w-full bg-deep-navy" data-id="element-300" data-mp="1200f1ec9e74q">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20" data-id="element-301" data-mp="wzky6csrqhi0">
        <div className="mx-auto max-w-2xl text-center" data-id="element-302" data-mp="x1yrag3w1jmx">
          <p className="text-sm font-semibold uppercase tracking-wide text-sky-blue" data-id="element-303" data-mp="sxr2yk1ce5p8">
            安心して始められる理由
          </p>
          <h2 className="mt-3 text-2xl font-bold text-white sm:text-3xl" data-id="element-304" data-mp="o1is3iu6gynv">
            むずかしさも、初期費用も、いりません
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/75" data-id="element-305" data-mp="e9mhx9ethi3a">
            実績を大きく語るより、まず「始めやすさ」をお約束します。下記はサービスの仕様です。
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-3" data-id="element-306" data-mp="9buo29um3lwg">
          <StatCard value={24} suffix="時間" label="365日対応（年中無休）" accent="sky" icon={<ClockIcon className="h-6 w-6" aria-hidden="true" data-id="element-308" data-mp="b6bzkos3vm7" />} data-id="element-307" data-mp="58on9hq9qmxd" />
          <StatCard value={1} suffix="日〜" label="最短での導入スピード" accent="amber" icon={<ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-310" data-mp="2oon7gl4xh43j" />} data-id="element-309" data-mp="2jwn38ghtrp15" />
          <StatCard value={0} prefix="¥" label="初期費用・IT知識ゼロでOK" accent="sage" icon={<WalletIcon className="h-6 w-6" aria-hidden="true" data-id="element-312" data-mp="2eylog7rfmbvh" />} data-id="element-311" data-mp="2ax9trntpb0gf" />
        </div>
      </div>
    </section>;
}